//
// Module for the Employer Reporting Maintenance Batch Members view
//
rs.module("content/employer/reporting/maintenance/batchmembers",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, transmittalKey, jsSelectors, backendUrl) {

            // Unpack Js Selectors
            var filter = $.js(jsSelectors.filter);

            var selectedSSNInput = filter.js(jsSelectors.selectedSSNInput);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // By default forms will submit when Enter is pressed, this suppresses that behavior and 
            // instead updates the grid
            selectedSSNInput.on("keydown",
                function (event) {
                    if (event.which == 13) {
                        event.preventDefault();
                        updateGridDisplay();
                    }
                }
            );

            // Listen for drop down select change
            selectedSSNInput.change(function () {
                updateGridDisplay();
            });

            // Populate Grid
            function updateGridDisplay() {
                loadingSpinner.show();

                // Update the grid
                gridModule.update(
                    backendUrl,
                    { transmittalBatchKey: transmittalKey, ssn: selectedSSNInput.val() },
                    lrsGridApi.agGridApi,
                    function done(gridUpate) {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);